import { useEffect, useState } from "react";
import api from "@/lib/api";
import { NewsletterBlock } from "@/components/Layout";
import { useContent } from "@/context/ContentContext";
import { HomeHero, HomeStats, HomeServices, HomeLatest, HomeAITeaser } from "@/pages/home/sections";
import Seo, { SITE } from "@/components/Seo";

export default function Home() {
  const c = useContent();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <div className="pt-20">
      <Seo
        title="Kim Kornachuk | Product Marketing & GTM Leader | B2B Growth from Ground Zero"
        description="Product marketing and GTM leader with 13+ years building B2B marketing functions from zero across SaaS, fintech, and AI. Demand generation, ABM, and GEO insights."
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Kim Kornachuk",
            url: SITE,
          },
          {
            "@context": "https://schema.org",
            "@type": "Person",
            name: "Kim Kornachuk",
            alternateName: "Kimberly Dotado-Kornachuk",
            jobTitle: "Product Marketing & GTM Leader",
            url: SITE,
            sameAs: [c.footer?.linkedin, c.footer?.instagram].filter(Boolean),
          },
        ]}
      />
      <HomeHero c={c} />
      <HomeStats c={c} />
      <HomeServices c={c} />
      <HomeLatest c={c} posts={posts} />
      <HomeAITeaser c={c} />
      <NewsletterBlock />
    </div>
  );
}
